import posthog from 'posthog-js';
import getEnvironment from '../../utils/getEnvironment';

class AnalyticsService {
  getPosthogClient = () => {
    if (typeof window !== 'undefined' && window.posthog) {
      return window.posthog;
    }
    return posthog;
  };

  init = () => {
    const environment = getEnvironment();
    this.registerGlobalProperties({
      environment,
      env: environment
    });
  };

  identifyUser = ({ userId, email, name }) => {
    if (!userId) return;

    const client = this.getPosthogClient();
    if (!client || typeof client.identify !== 'function') return;

    client.identify(String(userId), {
      email: email || '',
      name: name || ''
    });
  };

  registerGlobalProperties = (properties = {}) => {
    const client = this.getPosthogClient();
    if (!client || typeof client.register !== 'function') return;

    client.register(properties);
  };

  registerUserContext = ({ clientId, userId, userRole }) => {
    const environment = getEnvironment();

    this.registerGlobalProperties({
      client_id: clientId || null,
      user_id: userId || null,
      user_role: userRole || null,
      environment,
      env: environment
    });
  };

  capture = (eventName, properties = {}) => {
    if (!eventName) return;

    const client = this.getPosthogClient();
    if (!client || typeof client.capture !== 'function') return;

    client.capture(eventName, properties);
  };
}

export default new AnalyticsService();
